import type { DeckStatusResponse } from "./admin-api"

import { fetchDeckStatus } from "./admin-api"

const TERMINAL_STATUSES = new Set<DeckStatusResponse["processing_status"]>([
  "completed",
  "completed_with_errors",
  "failed",
])

/**
 * Poll until a deck reaches a terminal processing status.
 * Used by sequential bulk reprocess so each deck finishes before the next starts.
 */
export function waitForDeckProcessing(
  deckId: string,
  options: { pollIntervalMs?: number; timeoutMs?: number } = {}
): Promise<DeckStatusResponse> {
  const pollIntervalMs = options.pollIntervalMs ?? 3000
  const timeoutMs = options.timeoutMs ?? 5 * 60 * 1000
  const started = Date.now()

  return new Promise((resolve, reject) => {
    const tick = async () => {
      if (Date.now() - started > timeoutMs) {
        reject(new Error("timeout"))
        return
      }
      try {
        const status = await fetchDeckStatus(deckId)
        if (TERMINAL_STATUSES.has(status.processing_status)) {
          resolve(status)
          return
        }
      } catch (err) {
        reject(err)
        return
      }
      setTimeout(() => {
        void tick()
      }, pollIntervalMs)
    }
    void tick()
  })
}
